import { transactionConstants } from '../constants';
import { transactionService } from '../../services';

export const transactionActions = {
  transactionsList,
}

/*
ACTION: Transactions List
*/
function transactionsList(pageID, perPage, startDate, endDate) {
  return dispatch => {
    dispatch(request());
    return transactionService.transactionsList(pageID, perPage, startDate, endDate)
      .then(
        response => {
          dispatch(success(response.data.body.payments, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: transactionConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: transactionConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: transactionConstants.GETALL_FAILURE, error } }
}